export default "/images/vendor/flag-icon-css/flags/1x1/sb.svg?149bbf5e3a1e55db7588dd7b2a90c9ac";